export default "__VITE_PUBLIC_ASSET__fa7b5f96__"